import React, { Component } from "react";
//import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import DreamsTableSearch from "./dreamsTableSearch";
//import DreamsTableMuraqeeb from "./dreamsTableMuraqeeb";
import AllDreams from "./allDreams";
import ListGroup from "./common/listGroup2";
import Pagination from "./common/pagination";
import {
  saveDream,
  getDreamsThisMonth,
  getDreamsReply,
  saveBulkDream,
  getSearchMob,
  getNonReplyMobDataDreams,
  getSearch,
  getCashU_MT_locked
} from "../services/dreamService";
import NavBar from "./navBar";
import { paginate } from "../utils/paginate";
import _ from "lodash";
import auth from "../services/authService";
import Modal from "react-modal";

//import Moment from 'react-moment';
//import SearchBox from "./searchBox";

// import firebase from "firebase/app";
// import "firebase/database";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import SearchBox2 from "./searchBox2";

Modal.setAppElement("#root");

class DreamsSearch extends Component {
  state = {
    dreams: [],

    alldata: [],
    loading: true,
    sc: [],
    listOfFillter: [],
    todayCount: 0,
    yesterdayCount: 0,
    mudakekCount: 0,
    currentPage: 1,
    pageSize: 100,
    searchQuery: "",
    searchQuery2: "",
    selectedGenre: "مفسر اليوم",
    sortColumn: { path: "MO_Date", order: "asc" },
    user: "",
    loadeddata: true,
    replyDreams: [],
    deleteDreams: [],
    tadkeeqDreams: [],
    modalIsOpen: false,
    checker: false,
    isFillterbyMob: false,
    dataMuraqeeb: [],
    lastID: 0,
    OfflineData: [],
    isOffline: false,
    slectedMo: null,
    key: "0",
    todaysms: 0,
    monthsms: 0,
    currentSC: null,
    shouldHide: true,
    dreamsNONReplyMob: [],
    mobile: "",
    loadSearchData: false,
    take: 500,
    skip: 0,
    years: [],
    year: 0
  };

  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  async openModal(dream) {
    // let alldata = await getOldDreams(dream.MT_Mobil.replace("+", ""));
    // alldata = [...alldata.data.Data, ...alldata.data.OldData];
    // this.setState({ modalIsOpen: true, alldata });
    const mob = dream.MT_Mobil.replace("+", "");
    //window.location =   ;
    window.open("/alldreams/" + mob, "_blank");
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  async componentDidMount() {
    const email = auth.getCurrentUser();
    if (
      email.toLowerCase().startsWith("adib") ||
      email.toLowerCase().startsWith("mohannad")
    ) {
      //let unique = [...new Set(data.map(item => item.Group))];
      const email = auth.getCurrentUser();
      const data = await getDreamsThisMonth();
      let data12 = localStorage.getItem("OfflineData");
      if (data12) {
        if (!data12.startsWith("[")) {
          data12 = "[" + data12 + "]";
        }
      }

      let OfflineData = JSON.parse(data12);
      // const OfflineData=JSON.parse(localStorage.getItem("OfflineData"));
      const sc_new = [
        {
          title: "الكل",
          active: false
        },
        {
          title: "مفسر",
          active: false
        },
        {
          title: "محذوف",
          active: false
        },
        {
          title: "غير محذوف",
          active: false
        },
        {
          title: "غير مفسر",
          active: false
        },
        {
          title: "مفسر اليوم",
          active: true
        },
        {
          title: "مفسر البارحة",
          active: false
        },
        {
          title: "مفسر هذا الشهر",
          active: false
        },
        {
          title: "محذوف اليوم",
          active: false
        },
        {
          title: "محذوف البارحة",
          active: false
        },
        {
          title: "محذوف هذا الشهر",
          active: false
        },

        {
          title: "أحمد",
          active: false
        },
        {
          title: "الشيخ أديب",
          active: false
        },
        {
          title: "مفسرين آخرون",
          active: false
        }
      ];
      const years = [2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011];
      const year = new Date().getFullYear();

      const sc = data.data.SC;

      var dreams = data.data.Data;
      var dreamId = dreams[0]["ReplyID"];
      ////console.log(dreamId);
      const key = localStorage.getItem("userId");
      // var dreams=data.Data.filter(a=> a.isdelete===false && a.isSent ===false)
      this.setState({
        dreams: dreams,
        sc,
        year,
        years,
        loading: false,
        user: email,
        lastID: dreamId,
        OfflineData,
        listOfFillter: sc_new,
        key
      });
    }
  }

  renderSortIcon = () => {
    const { sortColumn } = this.state;

    if ("MO_Date" !== sortColumn.path) return null;

    if (sortColumn.order === "asc") return <i className="fa fa-sort-asc" />;
    return <i className="fa fa-sort-desc" />;
  };

  handleGetAll = async mobile => {
    const mob = mobile.replace("+", "");

    // //console.log(mob);
    const dreamsNONReplyMob = await getNonReplyMobDataDreams(mob);

    //console.log(dreamsNONReplyMob.data.Data);
    this.setState({
      shouldHide: false,
      mobile: mob,
      dreamsNONReplyMob: dreamsNONReplyMob.data.Data
    });
    await getCashU_MT_locked(this.state.user, mob, true);
    //  //console.log(this.state.dreamsNONReplyMob);
    // //window.location =   ;
    // window.open("/alldreams/" + mob,   "_blank" ).opener = null;
  };
  onUnLockAll = async mobile => {
    //  const mob = mobile.replace("+", "");

    this.setState({
      shouldHide: true,
      mobile: "",
      dreamsNONReplyMob: []
    });
    // const dreamsNONReplyMob=await  getNonReplyMobDataDreams(mob);
    await getCashU_MT_locked(this.state.user, mobile, false);
    // //window.location =   ;
    // window.open("/alldreams/" + mob,   "_blank" ).opener = null;
  };

  handlerefreshData = async () => {
    this.setState({
      loadeddata: false
    });
    let data = localStorage.getItem("OfflineData");
    if (data) {
      if (!data.startsWith("[")) {
        data = "[" + data + "]";
      }
    }

    let OfflineData = JSON.parse(data);
    if (this.state.selectedGenre === "تدقيق") {
      // let dataMuraqeeb = await getDreamsMuraqeeb();
      // dataMuraqeeb = dataMuraqeeb.data.Data;
      // this.setState({
      //   dataMuraqeeb
      // });

      const data = await getDreamsReply();
      let dreams = data.data.Data;

      this.setState({
        dreams: dreams,
        todayCount: data.data.TodayCount,
        yesterdayCount: data.data.YesterdayCount,
        mudakekCount: data.data.TodayCountMuraqeeb,
        todaysms: data.data.TodaySMS,
        monthsms: data.data.MonthSMS,
        loading: false,
        loadeddata: true,
        OfflineData
      });
    } else {
      const data = await getDreamsReply();
      let dreams = data.data.Data;

      this.setState({
        dreams: dreams,
        todayCount: data.data.TodayCount,
        yesterdayCount: data.data.YesterdayCount,
        mudakekCount: data.data.TodayCountMuraqeeb,
        todaysms: data.data.TodaySMS,
        monthsms: data.data.MonthSMS,
        loading: false,
        loadeddata: true
      });
      // let dataMuraqeeb = await getDreamsMuraqeeb();
      // dataMuraqeeb = dataMuraqeeb.data.Data;
      // this.setState({
      //   dataMuraqeeb
      // });
    }
  };

  renderSortDate = () => {
    const { sortColumn } = this.state;

    sortColumn.order === "asc"
      ? this.setState({ sortColumn: { path: "MO_Date", order: "desc" } })
      : this.setState({ sortColumn: { path: "MO_Date", order: "asc" } });
    if (sortColumn.order === "asc") {
      return <i className="fa fa-sort-asc" />;
    } else {
      return <i className="fa fa-sort-desc" />;
    }
  };

  handleDeleteConfirm = dream => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>حذف الحلم</h1>
            <p>هل ترغب بحذف الحلم</p>
            <button onClick={onClose}>لا</button>
            <button
              onClick={() => {
                this.handleDelete(dream);
                onClose();
              }}
            >
              نعم قم بحذفه
            </button>
          </div>
        );
      }
    });
  };

  handlerCBMob = event => {
    this.setState({ isFillterbyMob: event.target.checked });
  };

  handlerCBOffline = event => {
    this.setState({ isOffline: event.target.checked });
  };
  getMobFoucs = (dream, name, val) => {
    /*  if (this.state.isFillterbyMob) {
      const slectedMo = dream["MT_Mobil"];
      const dreams = [...this.state.dreams];

      const index = dreams.indexOf(dream);

      dreams[index][name] = val;

      this.setState({ slectedMo, dreams });
    } else {
      const dreams = [...this.state.dreams];

      const index = dreams.indexOf(dream);

      dreams[index][name] = val;

      this.setState({ dreams });
    } */
  };

  handleDelete = async dream => {
    dream["UserTranslate"] = this.state.lastID;
    ////console.log(dream);

    if (this.state.selectedGenre === "تدقيق") {
      dream["MT_Date"] = new Date();
      dream["ReplyDate"] = new Date();
      dream["isdelete"] = true;
      dream["ReplyUserName"] = this.state.user;

      const deleteDreams = [...this.state.deleteDreams, dream];

      const originalDreams = this.state.dataMuraqeeb;

      const dreams = originalDreams.filter(m => m.ReplyID !== dream.ReplyID);
      // //console.log(this.state.shouldHide);
      if (!this.state.shouldHide) {
        let dreamsNONReplyMob = this.state.dreamsNONReplyMob.filter(
          m => m.ReplyID !== dream.ReplyID
        );

        let shouldHide = false;

        //  //console.log(dreamsNONReplyMob.length);
        if (dreamsNONReplyMob.length === 0) {
          shouldHide = true;

          const mobile = "";
          dreamsNONReplyMob = [];
          this.setState({
            dreams,
            deleteDreams,
            dreamsNONReplyMob,
            shouldHide,
            mobile
          });
        } else {
          shouldHide = false;
          this.setState({
            dreams,
            deleteDreams,
            dreamsNONReplyMob,
            shouldHide
          });
        }
      } else {
        this.setState({ dreams, deleteDreams });
      }

      try {
        if (this.state.isOffline) {
          let data = localStorage.getItem("OfflineData");
          if (data) {
            if (!data.startsWith("[")) {
              data = "[" + data + "]";
            }
          }
          let offlinedata = JSON.parse(data);
          //let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
          if (offlinedata) {
            offlinedata = [...offlinedata, dream];
            this.setState({ OfflineData: offlinedata });
            offlinedata = JSON.stringify(offlinedata);
            localStorage.setItem("OfflineData", offlinedata);
          } else {
            this.setState({ OfflineData: dream });
            localStorage.setItem("OfflineData", JSON.stringify(dream));
          }
          return;
        }

        let data = await saveDream(dream);

        // if (data.data.Data) {
        //   let newDreams = [...this.state.dreams, data.data.Data];

        //   this.setState({
        //     dreams: newDreams
        //   });
        // }
        // if (data.data.Muraqeeb) {
        //   let Muraqeeb = data.data.Muraqeeb;

        //   this.setState({
        //     dataMuraqeeb: Muraqeeb
        //   });
        // }

        this.setState({
          todayCount: data.data.TodayCount,
          //   yesterdayCount: data.data.YesterdayCount,
          mudakekCount: data.data.TodayCountMuraqeeb
          //    todaysms: data.data.TodaySMS,
          //    monthsms: data.data.MonthSMS
        });
        /*       const dataNew = await getDreams();
        let dreamsNew = dataNew.data.Data;
        let dataMuraqeeb = await getDreamsMuraqeeb();
        dataMuraqeeb=dataMuraqeeb.data.Data;
        this.setState({
          dataMuraqeeb,
          dreams:dreamsNew
        }); */
        toast.info("تم الحذف بنجاح", {
          position: toast.POSITION.BOTTOM_LEFT
        });
      } catch (ex) {
        toast.error("يوجد خطأ بالحذف ", {
          position: toast.POSITION.BOTTOM_LEFT
        });
        if (ex.response && ex.response.status === 404)
          toast.error("This dream has already been deleted.");
      }
    } else {
      dream["MT_Date"] = new Date();
      dream["ReplyDate"] = new Date();
      dream["isdelete"] = true;
      dream["ReplyUserName"] = this.state.user;

      const deleteDreams = [...this.state.deleteDreams, dream];

      const originalDreams = this.state.dreams;

      const dreams = originalDreams.filter(m => m.ReplyID !== dream.ReplyID);
      if (!this.state.shouldHide) {
        let dreamsNONReplyMob = this.state.dreamsNONReplyMob.filter(
          m => m.ReplyID !== dream.ReplyID
        );

        let shouldHide = false;

        //  //console.log(dreamsNONReplyMob.length);
        if (dreamsNONReplyMob.length === 0) {
          shouldHide = true;

          const mobile = "";
          dreamsNONReplyMob = [];
          this.setState({
            dreams,
            deleteDreams,
            dreamsNONReplyMob,
            shouldHide,
            mobile
          });
        } else {
          shouldHide = false;
          this.setState({
            dreams,
            deleteDreams,
            dreamsNONReplyMob,
            shouldHide
          });
        }
      } else {
        this.setState({ dreams, deleteDreams });
      }

      try {
        if (this.state.isOffline) {
          let data = localStorage.getItem("OfflineData");
          if (data) {
            if (!data.startsWith("[")) {
              data = "[" + data + "]";
            }
          }
          let offlinedata = JSON.parse(data);
          // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
          if (offlinedata) {
            offlinedata = [...offlinedata, dream];
            this.setState({ OfflineData: offlinedata });
            offlinedata = JSON.stringify(offlinedata);
            localStorage.setItem("OfflineData", offlinedata);
          } else {
            this.setState({ OfflineData: dream });
            localStorage.setItem("OfflineData", JSON.stringify(dream));
          }
          return;
        }

        let data = await saveDream(dream);
        /*       const dataNew = await getDreams();
        let dreamsNew = dataNew.data.Data;
        let dataMuraqeeb = await getDreamsMuraqeeb();
        dataMuraqeeb=dataMuraqeeb.data.Data;
        this.setState({
          dataMuraqeeb,
          dreams:dreamsNew
        }); */

        // if (data.data.Data) {
        //   let newDreams = [...this.state.dreams, data.data.Data];

        //   this.setState({
        //     dreams: newDreams
        //   });
        // }
        // if (data.data.Muraqeeb) {
        //   let Muraqeeb = data.data.Muraqeeb;

        //   this.setState({
        //     dataMuraqeeb: Muraqeeb
        //   });
        // }

        this.setState({
          todayCount: data.data.TodayCount,
          //  yesterdayCount: data.data.YesterdayCount,
          mudakekCount: data.data.TodayCountMuraqeeb
          // todaysms: data.data.TodaySMS,
          //  monthsms: data.data.MonthSMS
        });
        toast.info("تم الحذف بنجاح", {
          position: toast.POSITION.BOTTOM_LEFT
        });
      } catch (ex) {
        toast.error("يوجد خطأ بالحذف ", {
          position: toast.POSITION.BOTTOM_LEFT
        });
        if (ex.response && ex.response.status === 404)
          toast.error("This dream has already been deleted.", {
            position: toast.POSITION.BOTTOM_LEFT
          });
      }
    }
  };

  handleKeywordsMsg = async (dream, keywords, pStatus) => {
    dream["UserTranslate"] = this.state.lastID;
    if (keywords.length === 0 || keywords === " ") {
      toast.error("اكتب الرموز اولا ");
      return;
    }

    dream["MT_Englsih"] = keywords.replace(" ", "-");

    dream["PersonStatus"] = pStatus;
    dream["ReplyUserName"] = this.state.user;

    const originalDreams = this.state.dreams;

    //  const dreams = originalDreams.filter(m => m.ReplyID !== dream.ReplyID);
    const replyDreams = [...this.state.replyDreams, dream];

    this.setState({ dreams: originalDreams, replyDreams });

    try {
      if (this.state.isOffline) {
        let data = localStorage.getItem("OfflineData");
        if (data) {
          if (!data.startsWith("[")) {
            data = "[" + data + "]";
          }
        }
        let offlinedata = JSON.parse(data);
        // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
        if (offlinedata) {
          offlinedata = [...offlinedata, dream];
          this.setState({ OfflineData: offlinedata });
          offlinedata = JSON.stringify(offlinedata);
          localStorage.setItem("OfflineData", offlinedata);
        } else {
          this.setState({ OfflineData: dream });
          localStorage.setItem("OfflineData", JSON.stringify(dream));
        }
        return;
      }

      await saveDream(dream);
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast.error("This dream has already been deleted.", {
          position: toast.POSITION.BOTTOM_LEFT
        });
    }

    /*  const dataNew = await getDreams();
        let dreamsNew = dataNew.data.Data;
        let dataMuraqeeb = await getDreamsMuraqeeb();
        dataMuraqeeb=dataMuraqeeb.data.Data;
        this.setState({
          dataMuraqeeb,
          dreams:dreamsNew
        }); */
  };

  sentOfflineData = async () => {
    let data = localStorage.getItem("OfflineData");
    if (data) {
      if (!data.startsWith("[")) {
        data = "[" + data + "]";
      }
    }
    let offlinedata = JSON.parse(data);
    localStorage.removeItem("OfflineData");
    ////console.log(data);

    this.setState({
      OfflineData: null
    });

    try {
      let data = await saveBulkDream(offlinedata);

      // let newDreams = data.data.Data;

      // let Muraqeeb = data.data.Muraqeeb;

      this.setState({
        //  dreams: newDreams,
        //    dataMuraqeeb: Muraqeeb,
        todayCount: data.data.TodayCount,
        //   yesterdayCount: data.data.YesterdayCount,
        mudakekCount: data.data.TodayCountMuraqeeb
        //    todaysms: data.data.TodaySMS,
        //   monthsms: data.data.MonthSMS
      });
      toast.info("تم الارسال لكل أحلام الأوفلاين بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT
      });
    } catch (ex) {
      toast.error("يوجد خطأ بالارسال ", {
        position: toast.POSITION.BOTTOM_LEFT
      });

      this.setState({
        OfflineData: offlinedata.length
      });

      localStorage.setItem("OfflineData", JSON.stringify(offlinedata));

      if (ex.response && ex.response.status === 404)
        toast.error("This dream has already been deleted.", {
          position: toast.POSITION.BOTTOM_LEFT
        });
    }
  };

  handleChangeInput = (dream, name, val) => {
    //  if(input.value.length < 10){
    // return  toast.error("الرسالة أقل من 10 حروف ");
    //  }
    // //console.log(name + "  " + val);
    const dreams = [...this.state.dreams];

    function checkDream(dreams) {
      return dreams.ReplyID === dream.ReplyID;
    }

    const index = dreams.findIndex(checkDream);

    if (!this.state.shouldHide) {
      const dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];

      const indexM = dreamsNONReplyMob.findIndex(checkDream);
      // this.setState({ dreams, deleteDreams,dreamsNONReplyMob });
      dreamsNONReplyMob[indexM][name] = val;

      dreams[index][name] = val;

      this.setState({ dreams, dreamsNONReplyMob });
    } else {
      //console.log(name);
      dreams[index][name] = val;

      this.setState({ dreams });
    }
  };

  handleSendMsg = async dream => {
    // dream["UserTranslate"] = this.state.lastID;
    // //console.log(dream );

    //    function checkDream(dreams) {
    //     return dreams.ReplyID === dream.ReplyID;
    // }

    if (dream["MT_Reply_Msg"].length < 7) {
      toast.error("اكتب الرسالة اولا ", {
        position: toast.POSITION.BOTTOM_LEFT
      });
      return;
    }

    if (this.state.selectedGenre === "تدقيق") {
      dream["ReplyDate"] = new Date();
      dream["isRedyToSent"] = true;


      dream["MsgRegFroSend"] = dream["MsgRegFroSend"] + 1;
      // dream["MT_Reply_Msg"] = msg;
      dream["MT_NoOfMsg"] = dream["MT_Reply_Msg"].length;
      dream["IsPending"] = true;
      dream["IsReply"] = true;

      // dream["PersonStatus"] = pStatus;

      dream["ReplyUserName"] = this.state.user;

      const originalDreams = this.state.dataMuraqeeb;

      const dataMuraqeeb = originalDreams.filter(
        m => m.ReplyID !== dream.ReplyID
      );

      if (!this.state.shouldHide) {
        let dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
        dreamsNONReplyMob = dreamsNONReplyMob.filter(
          m => m.ReplyID !== dream.ReplyID
        );
        // this.setState({ dreams, deleteDreams,dreamsNONReplyMob });
        let shouldHide = false;
        // //console.log(dreamsNONReplyMob.length===0);
        if (dreamsNONReplyMob.length === 0) {
          shouldHide = true;

          const mobile = "";
          dreamsNONReplyMob = [];
          //console.log(dreamsNONReplyMob.length);
          this.setState({
            dataMuraqeeb,
            dreamsNONReplyMob,
            shouldHide,
            mobile
          });
        } else {
          shouldHide = false;
          this.setState({ dataMuraqeeb, dreamsNONReplyMob, shouldHide });
        }
      } else {
        this.setState({ dataMuraqeeb });
      }

      // const replyDreams = [...this.state.replyDreams, dream];

      try {
        if (this.state.isOffline) {
          let data = localStorage.getItem("OfflineData");
          if (data) {
            if (!data.startsWith("[")) {
              data = "[" + data + "]";
            }
          }
          let offlinedata = JSON.parse(data);
          // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
          if (offlinedata) {
            offlinedata = [...offlinedata, dream];
            this.setState({ OfflineData: offlinedata });
            offlinedata = JSON.stringify(offlinedata);
            localStorage.setItem("OfflineData", offlinedata);
          } else {
            this.setState({ OfflineData: dream });
            localStorage.setItem("OfflineData", JSON.stringify(dream));
          }
          return;
        }

        let data = await saveDream(dream);

        // if (data.data.Data) {
        //   let newDreams = [...this.state.dreams, data.data.Data];

        //   this.setState({
        //     dreams: newDreams
        //   });
        // }
        // if (data.data.Muraqeeb) {
        //   let Muraqeeb = data.data.Muraqeeb;

        //   this.setState({
        //     dataMuraqeeb: Muraqeeb
        //   });
        // }

        this.setState({
          todayCount: data.data.TodayCount,
          // yesterdayCount: data.data.YesterdayCount,
          mudakekCount: data.data.TodayCountMuraqeeb
          //  todaysms: data.data.TodaySMS,
          // monthsms: data.data.MonthSMS
        });
        toast.success("تم الارسال بنجاح", {
          position: toast.POSITION.BOTTOM_LEFT
        });
      } catch (ex) {
        toast.error("يوجد خطأ بالارسال ", {
          position: toast.POSITION.BOTTOM_LEFT
        });
        const originalDreams = [...this.state.dataMuraqeeb, dream];
        let data = localStorage.getItem("OfflineData");
        if (data) {
          if (!data.startsWith("[")) {
            data = "[" + data + "]";
          }
        }
        let offlinedata = JSON.parse(data);
        // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
        if (offlinedata) {
          offlinedata = [...offlinedata, dream];
          this.setState({ OfflineData: offlinedata });
          offlinedata = JSON.stringify(offlinedata);
          localStorage.setItem("OfflineData", offlinedata);
        } else {
          this.setState({ OfflineData: dream });
          localStorage.setItem("OfflineData", JSON.stringify(dream));
        }
        this.setState({ dataMuraqeeb: originalDreams });
        if (ex.response && ex.response.status === 404)
          toast.error("This dream has already been deleted.", {
            position: toast.POSITION.BOTTOM_LEFT
          });
      }
    } else {
      dream["MT_Date"] = new Date();
      dream["ReplyDate"] = new Date();
      dream["isRedyToSent"] = true;
      dream["MsgRegFroSend"] = dream["MsgRegFroSend"] + 1;
      // dream["MT_Reply_Msg"] = msg;
      dream["MT_NoOfMsg"] = dream["MT_Reply_Msg"].length;
      dream["IsPending"] = true;
      dream["IsReply"] = true;
      // dream["MT_Englsih"]=key_words;
      //dream["PersonStatus"] = pStatus;
      dream["ReplyUserName"] = this.state.user;

      const originalDreams = this.state.dreams;

      const dreams = originalDreams.filter(m => m.ReplyID !== dream.ReplyID);

      //const replyDreams = [...this.state.replyDreams, dream];
      if (!this.state.shouldHide) {
        let dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
        dreamsNONReplyMob = dreamsNONReplyMob.filter(
          m => m.ReplyID !== dream.ReplyID
        );
        // this.setState({ dreams, deleteDreams,dreamsNONReplyMob });
        let shouldHide = false;
        if (dreamsNONReplyMob.length === 0) {
          shouldHide = true;

          const mobile = "";
          dreamsNONReplyMob = [];
          this.setState({ dreams, dreamsNONReplyMob, shouldHide, mobile });
        } else {
          shouldHide = false;
          this.setState({ dreams, dreamsNONReplyMob, shouldHide });
        }
      } else {
        this.setState({ dreams });
      }

      //  this.setState({ dreams });

      try {
        if (this.state.isOffline) {
          let data = localStorage.getItem("OfflineData");
          if (data) {
            if (!data.startsWith("[")) {
              data = "[" + data + "]";
            }
          }
          let offlinedata = JSON.parse(data);
          // let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
          if (offlinedata) {
            offlinedata = [...offlinedata, dream];
            this.setState({ OfflineData: offlinedata });
            offlinedata = JSON.stringify(offlinedata);
            localStorage.setItem("OfflineData", offlinedata);
          } else {
            this.setState({ OfflineData: dream });
            localStorage.setItem("OfflineData", JSON.stringify(dream));
          }
          return;
        }

        // await saveDream(dream);
        let data = await saveDream(dream);

        // if (data.data.Data) {
        //   let newDreams = [...this.state.dreams, data.data.Data];

        //   this.setState({
        //     dreams: newDreams
        //   });
        // }
        // if (data.data.Muraqeeb) {
        //   let Muraqeeb = data.data.Muraqeeb;

        //   this.setState({
        //     dataMuraqeeb: Muraqeeb
        //   });
        // }

        this.setState({
          todayCount: data.data.TodayCount,
          //  yesterdayCount: data.data.YesterdayCount,
          mudakekCount: data.data.TodayCountMuraqeeb
          //  todaysms: data.data.TodaySMS,
          //   monthsms: data.data.MonthSMS
        });
        toast.success("تم الارسال بنجاح", {
          position: toast.POSITION.BOTTOM_LEFT
        });
      } catch (ex) {
        toast.error("يوجد خطأ بالارسال ", {
          position: toast.POSITION.BOTTOM_LEFT
        });

        const originalDreams = [...this.state.dreams, dream];

        let data = localStorage.getItem("OfflineData");
        if (data) {
          if (!data.startsWith("[")) {
            data = "[" + data + "]";
          }
        }
        let offlinedata = JSON.parse(data);
        //   let offlinedata=JSON.parse(localStorage.getItem("OfflineData"));
        if (offlinedata) {
          offlinedata = [...offlinedata, dream];
          this.setState({ OfflineData: offlinedata });
          offlinedata = JSON.stringify(offlinedata);
          localStorage.setItem("OfflineData", offlinedata);
        } else {
          this.setState({ OfflineData: dream });
          localStorage.setItem("OfflineData", JSON.stringify(dream));
        }
        this.setState({ dreams: originalDreams });
        if (ex.response && ex.response.status === 404)
          toast.error("This dream has already been deleted.", {
            position: toast.POSITION.BOTTOM_LEFT
          });
      }
    }
  };

  handleLike = async dream => {
    function checkDream(dreams) {
      return dreams.ReplyID === dream.ReplyID;
    }

    dream["UserTranslate"] = this.state.lastID;
    const dreams = [...this.state.dreams];
    const index = dreams.findIndex(checkDream);
    if (!this.state.shouldHide) {
      const dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
      const indexM = dreamsNONReplyMob.findIndex(checkDream);

      dreamsNONReplyMob[indexM].isprivate = !dreamsNONReplyMob[indexM]
        .isprivate;
      dreams[index] = { ...dreams[index] };
      dreams[index].isprivate = !dreams[index].isprivate;
      dream.isprivate = !dream.isprivate;

      this.setState({ dreams, dreamsNONReplyMob });
    } else {
      dreams[index] = { ...dreams[index] };
      dreams[index].isprivate = !dreams[index].isprivate;
      dream.isprivate = !dream.isprivate;

      this.setState({ dreams });
    }

    try {
      let data = await saveDream(dream);

      // if (data.data.Data) {
      //   let newDreams = [...this.state.dreams, data.data.Data];

      //   this.setState({
      //     dreams: newDreams
      //   });
      // }
      // if (data.data.Muraqeeb) {
      //   let Muraqeeb = data.data.Muraqeeb;

      //   this.setState({
      //     dataMuraqeeb: Muraqeeb
      //   });
      // }

      this.setState({
        todayCount: data.data.TodayCount,
        //   yesterdayCount: data.data.YesterdayCount,
        mudakekCount: data.data.TodayCountMuraqeeb
        //  todaysms: data.data.TodaySMS,
        //    monthsms: data.data.MonthSMS
      });
      /*       const dataNew = await getDreams();
      let dreamsNew = dataNew.data.Data;
      let dataMuraqeeb = await getDreamsMuraqeeb();
      dataMuraqeeb=dataMuraqeeb.data.Data;
      this.setState({
        dataMuraqeeb,
        dreams:dreamsNew
      }); */
      toast.info("تم الحفظ بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT
      });
    } catch (ex) {
      toast.error("يوجد خطأ بالحفظ ", {
        position: toast.POSITION.BOTTOM_LEFT
      });
      if (ex.response && ex.response.status === 404)
        toast.error("This dream has already been deleted.");
    }
  };

  handleLock = async dream => {
    function checkDream(dreams) {
      return dreams.ReplyID === dream.ReplyID;
    }

    dream["UserTranslate"] = this.state.lastID;
    const dreams = [...this.state.dreams];
    const index = dreams.findIndex(checkDream);
    if (!this.state.shouldHide) {
      const dreamsNONReplyMob = [...this.state.dreamsNONReplyMob];
      const indexM = dreamsNONReplyMob.findIndex(checkDream);

      dreamsNONReplyMob[indexM].islock = !dreamsNONReplyMob[indexM].islock;
      dreams[index] = { ...dreams[index] };
      dreams[index].islock = !dreams[index].islock;
      dream.islock = !dream.islock;
      if (dream.islock) {
        dreams[index].Userlock = this.state.user;
        dreams[index].userlockDate = new Date();
        dream.userlockDate = new Date();
        dream.Userlock = this.state.user;

        dreamsNONReplyMob[indexM].Userlock = this.state.user;
        dreamsNONReplyMob[indexM].userlockDate = new Date();
      } else {
        dreams[index].Userlock = "";
        dreams[index].userlockDate = null;
        dream.userlockDate = null;
        dream.Userlock = "";

        dreamsNONReplyMob[indexM].Userlock = "";
        dreamsNONReplyMob[indexM].userlockDate = null;
      }

      this.setState({ dreams, dreamsNONReplyMob });
    } else {
      if (dream.islock) {
        dreams[index].Userlock = this.state.user;
        dreams[index].userlockDate = new Date();
        dream.userlockDate = new Date();
        dream.Userlock = this.state.user;
      } else {
        dreams[index].Userlock = "";
        dreams[index].userlockDate = null;
        dream.userlockDate = null;
        dream.Userlock = "";
      }
      dreams[index] = { ...dreams[index] };
      dreams[index].islock = !dreams[index].islock;
      dream.islock = !dream.islock;

      this.setState({ dreams });
    }

    // dreams[index] = { ...dreams[index] };
    // dreams[index].islock = !dreams[index].islock;
    // dream.islock = !dream.islock;

    // this.setState({ dreams });
    try {
      if (this.state.isOffline) {
      }

      let data = await saveDream(dream);

      // if (data.data.Data) {
      //   let newDreams = [...this.state.dreams, data.data.Data];

      //   this.setState({
      //     dreams: newDreams
      //   });
      // }
      // if (data.data.Muraqeeb) {
      //   let Muraqeeb = data.data.Muraqeeb;

      //   this.setState({
      //     dataMuraqeeb: Muraqeeb
      //   });
      // }

      this.setState({
        todayCount: data.data.TodayCount,
        //  yesterdayCount: data.data.YesterdayCount,
        mudakekCount: data.data.TodayCountMuraqeeb
        // todaysms: data.data.TodaySMS,
        //monthsms: data.data.MonthSMS
      });
      /*       const dataNew = await getDreams();
      let dreamsNew = dataNew.data.Data;
      let dataMuraqeeb = await getDreamsMuraqeeb();
      dataMuraqeeb=dataMuraqeeb.data.Data;
      this.setState({
        dataMuraqeeb,
        dreams:dreamsNew
      }); */
      toast.info("تم الحفظ بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT
      });
    } catch (ex) {
      toast.error("يوجد خطأ بالحفظ ", {
        position: toast.POSITION.BOTTOM_LEFT
      });
      if (ex.response && ex.response.status === 404)
        toast.error("This dream has already been deleted.", {
          position: toast.POSITION.BOTTOM_LEFT
        });
    }
    /*  const dataNew = await getDreams();
    let dreamsNew = dataNew.data.Data;
    let dataMuraqeeb = await getDreamsMuraqeeb();
    dataMuraqeeb=dataMuraqeeb.data.Data;
    this.setState({
      dataMuraqeeb,
      dreams:dreamsNew
    }); */
  };

  handlePageChange = page => {
    this.setState({ currentPage: page });
  };

  handleGenreSelect = genre => {
    //  //console.log(genre);
    if (genre["isSC"]) {
      if (genre["title"] === "الكل") {
        this.setState({
          // currentSC:genre['title'],
          selectedGenre: genre["title"],
          searchQuery: "",
          currentPage: 1,
          slectedMo: null,
          currentSC: null
        });
      } else {
        this.setState({
          currentSC: genre["title"],
          selectedGenre: genre["title"],
          searchQuery: "",
          currentPage: 1,
          slectedMo: null
        });
      }
    } else {
      const buttonsList = [...this.state.listOfFillter];
      const index = buttonsList.indexOf(genre);
      buttonsList[index] = { ...buttonsList[index] };
      let buttonListActive = buttonsList[index].active;
      if (index === 0) {
        buttonsList[1].active = false;
        buttonsList[2].active = false;
        buttonsList[3].active = false;
        buttonsList[4].active = false;
        buttonsList[5].active = false;
        buttonsList[6].active = false;
        buttonsList[7].active = false;
        buttonsList[8].active = false;
        buttonsList[9].active = false;
        buttonsList[10].active = false;
        buttonsList[11].active = false;
        buttonsList[12].active = false;
        buttonsList[13].active = false;
        buttonsList[14].active = false;
      }

      if (index >= 1 && index <= 3) {
        buttonsList[1].active = false;
        buttonsList[2].active = false;
        buttonsList[3].active = false;
        buttonsList[0].active = false;
      }
      if (index >= 4 && index <= 6) {
        buttonsList[4].active = false;
        buttonsList[5].active = false;
        buttonsList[6].active = false;
        buttonsList[0].active = false;
      }
      if (index >= 7 && index <= 9) {
        buttonsList[7].active = false;
        buttonsList[8].active = false;
        buttonsList[9].active = false;
        buttonsList[0].active = false;
      }
      if (index >= 10) {
        buttonsList[10].active = false;
        buttonsList[11].active = false;
        buttonsList[12].active = false;
        buttonsList[13].active = false;
        buttonsList[14].active = false;
        buttonsList[0].active = false;
      }

      ////console.log(buttonsList[index]);
      buttonsList[index].active = !buttonListActive;

      this.setState({
        listOfFillter: buttonsList,
        selectedGenre: genre["title"],
        searchQuery: "",
        currentPage: 1,
        slectedMo: null
      });
    }
  };
  handleNext = async () => {
    this.setState({
      loadSearchData: true,
      skip: this.state.skip + 500
    });
    let data;
    const query = (this.state.searchQuery2 || "").trim();
    if (!query) {
      this.setState({ loadSearchData: false });
      return;
    }
    const digits = query.replace(/\D/g, "");
    const isMobileSearch = digits.length >= 7;
    if (isMobileSearch) {
      data = await getSearchMob(digits);
    } else {
      data = await getSearch(query, this.state.year);
    }
    let newDreams;
    if (data.data.Data && data.data.OldData) {
      newDreams = [...data.data.Data, ...data.data.OldData];
      this.setState({
        loadSearchData: false,
        dreams: newDreams,
        searchQuery: ""
      });
    } else if (data.data.Data) {
      newDreams = data.data.Data;
      this.setState({
        loadSearchData: false,
        dreams: newDreams,
        searchQuery: ""
      });
    } else if (data.data.OldData) {
      newDreams = data.data.OldData;
      this.setState({
        loadSearchData: false,
        dreams: newDreams,
        searchQuery: ""
      });
    } else {
      this.setState({
        loadSearchData: false,
        dreams: [],
        searchQuery: ""
      });
    }
  };
  handleBack = async () => {
    const sk = this.state.skip - 500;

    if (this.state.skip < 0) {
      this.setState({
        loadSearchData: true,
        skip: 0
      });
    } else {
      this.setState({
        loadSearchData: true,
        skip: sk
      });
    }

    let data;
    const query = (this.state.searchQuery2 || "").trim();
    if (!query) {
      this.setState({ loadSearchData: false });
      return;
    }
    const digits = query.replace(/\D/g, "");
    const isMobileSearch = digits.length >= 7;
    if (isMobileSearch) {
      data = await getSearchMob(digits);
    } else {
      data = await getSearch(query, this.state.year);
    }

    let newDreams;
    if (data.data.Data && data.data.OldData) {
      newDreams = [...data.data.Data, ...data.data.OldData];
      this.setState({
        loadSearchData: false,
        dreams: newDreams,
        searchQuery: ""
      });
    } else if (data.data.Data) {
      newDreams = data.data.Data;
      this.setState({
        loadSearchData: false,
        dreams: newDreams,
        searchQuery: ""
      });
    } else if (data.data.OldData) {
      newDreams = data.data.OldData;
      this.setState({
        loadSearchData: false,
        dreams: newDreams,
        searchQuery: ""
      });
    } else {
      this.setState({
        loadSearchData: false,
        dreams: [],
        searchQuery: ""
      });
    }
  };
  handelSelect = async e => {
    const selectedYear = e.currentTarget.value;
    this.setState({
      loadSearchData: true,
      year: selectedYear
    });

    const query = (this.state.searchQuery2 || "").trim();
    if (!query) {
      this.setState({ loadSearchData: false });
      return;
    }

    let data;
    const digits = query.replace(/\D/g, "");
    const isMobileSearch = digits.length >= 7;
    if (isMobileSearch) {
      data = await getSearchMob(digits);
    } else {
      data = await getSearch(query, selectedYear);
    }

    let newDreams;
    if (data.data.Data && data.data.OldData) {
      newDreams = [...data.data.Data, ...data.data.OldData];
      this.setState({
        loadSearchData: false,
        dreams: newDreams,
        searchQuery: ""
      });
    } else if (data.data.Data) {
      newDreams = data.data.Data;
      this.setState({
        loadSearchData: false,
        dreams: newDreams,
        searchQuery: ""
      });
    } else if (data.data.OldData) {
      newDreams = data.data.OldData;
      this.setState({
        loadSearchData: false,
        dreams: newDreams,
        searchQuery: ""
      });
    } else {
      this.setState({
        loadSearchData: false,
        dreams: [],
        searchQuery: ""
      });
    }
  };
  handleKeyPress = async e => {
    // function isNumeric(input) {
    //   var number = "[0-9]";
    //   var regex = RegExp(number);
    //   return regex.test(input) && input.length > 0;
    // }
    if (e.key === "Enter") {
      const rawValue = String(e.currentTarget.value || "").trim();
      if (!rawValue) {
        this.setState({ searchQuery2: "", loadSearchData: false });
        return;
      }
      this.setState({
        loadSearchData: true,
        searchQuery2: rawValue,
        take: 2000,
        skip: 0
      });

      let data;
      const digits = rawValue.replace(/\D/g, "");
      const isMobileSearch = digits.length >= 7;
      if (isMobileSearch) {
        data = await getSearchMob(digits);
      } else {
        data = await getSearch(rawValue, this.state.year);
      }

      let newDreams;
      if (data.data.Data && data.data.OldData) {
        newDreams = [...data.data.Data, ...data.data.OldData];
        this.setState({
          loadSearchData: false,
          dreams: newDreams,
          searchQuery: ""
        });
      } else if (data.data.Data) {
        newDreams = data.data.Data;
        this.setState({
          loadSearchData: false,
          dreams: newDreams,
          searchQuery: ""
        });
      } else if (data.data.OldData) {
        newDreams = data.data.OldData;
        this.setState({
          loadSearchData: false,
          dreams: newDreams,
          searchQuery: ""
        });
      } else {
        this.setState({
          loadSearchData: false,
          dreams: [],
          searchQuery: ""
        });
      }
    }
  };

  handleSearch = async e => {
    this.setState({
      searchQuery: e.currentTarget.value,
      selectedGenre: null,
      currentPage: 1,
      slectedMo: null
    });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      sortColumn,
      listOfFillter,
      selectedGenre,
      searchQuery,
      replyDreams,
      dreams: allDreams,
      dataMuraqeeb,

      shouldHide,
      dreamsNONReplyMob
    } = this.state;
    let slectedMo: null;
    let filtered;

    if (!shouldHide) {
      filtered = dreamsNONReplyMob;
    } else {
      filtered = allDreams;

      //slectedMo:null
      slectedMo = this.state.slectedMo;
      if (this.state.slectedMo) {
        let allDreamsMuraqeeb = [...dataMuraqeeb, ...allDreams];
        let filtered_temp = allDreamsMuraqeeb.filter(m => {
          if (m["MT_Mobil"] === slectedMo) {
            return true;
          }

          return false;
        });

        if (filtered_temp.length > 1) {
          filtered = filtered_temp;
        } else {
          slectedMo = null;
        }
      }
      if (searchQuery) {
        slectedMo = null;
        // let allDreamsMuraqeebDelete=[...allDreams,...dataMuraqeeb];
        // allDreamsMuraqeebDelete=[...allDreamsMuraqeebDelete,...deleteDreams];
        filtered = allDreams.filter(m => {
          if (m["MO_Message"]) {
            var v = false;
            var boolarray = 0;

            var searcharr = searchQuery.split("-");
            if (searcharr.length > 0) {
              for (var i = 0; i < searcharr.length; i++) {
                if (m["MO_Message"].includes(searcharr[i])) {
                  boolarray++;
                }
              }
              if (boolarray && searcharr) {
                if (searcharr.length === boolarray) {
                  return true;
                }
              }
            }
            v =
              m["MO_Message"] === searchQuery ||
              m["MT_Mobil"] === searchQuery ||
              m["MT_Mobil"].includes(searchQuery) ||
              m["MO_Message"].includes(searchQuery);
            return v;
          } else {
            return (
              m["MO_Message"] === searchQuery || m["MT_Mobil"] === searchQuery
            );
          }
        });
      } else if (selectedGenre && selectedGenre) {
        slectedMo = null;
        //  filtered = allDreams;

        if (listOfFillter[0].active) {
          filtered = allDreams.filter(m => {
            return true;
          });
        } else {
          filtered = filtered.filter(m => {
            if (listOfFillter[1].active) {
              if (m["isSent"]) {
                return true;
              } else {
                return false;
              }
            } else if (listOfFillter[2].active) {
              if (m["isdelete"]) {
                return true;
              } else {
                return false;
              }
            } else if (listOfFillter[3].active) {
              if (!m["isdelete"]) {
                return true;
              } else {
                return false;
              }
            } else if (listOfFillter[4].active) {
              if (!m["isSent"]) {
                return true;
              } else {
                return false;
              }
            }
            return true;
          });
          filtered = filtered.filter(m => {
            if (listOfFillter[5].active) {
              var date = new Date(m["MO_Date"]);
              return (
                date.getDate() === new Date().getDate() &&
                date.getFullYear() === new Date().getFullYear() &&
                date.getMonth() === new Date().getMonth() &&
                m["isSent"]
              );
            } else if (listOfFillter[6].active) {
              let yesterday = (d => new Date(d.setDate(d.getDate() - 1)))(
                new Date()
              );
              var MO_Date = new Date(m["MO_Date"]);
              //# => Fri Apr 01 2011 11:14:50 GMT+0200 (CEST)

              return (
                MO_Date.getDate() === yesterday.getDate() &&
                MO_Date.getFullYear() === yesterday.getFullYear() &&
                MO_Date.getMonth() === yesterday.getMonth() &&
                m["isSent"]
              );
            } else if (listOfFillter[7].active) {
              var MO_Date_Month = new Date(m["MO_Date"]);
              //# => Fri Apr 01 2011 11:14:50 GMT+0200 (CEST)

              return (
                MO_Date_Month.getFullYear() === new Date().getFullYear() &&
                MO_Date_Month.getMonth() === new Date().getMonth() &&
                m["isSent"]
              );
            }
            return true;
          });
          filtered = filtered.filter(m => {
            if (listOfFillter[8].active) {
              var date = new Date(m["MO_Date"]);
              return (
                date.getDate() === new Date().getDate() &&
                date.getFullYear() === new Date().getFullYear() &&
                date.getMonth() === new Date().getMonth() &&
                m["isdelete"]
              );
            } else if (listOfFillter[9].active) {
              let yesterday = (d => new Date(d.setDate(d.getDate() - 1)))(
                new Date()
              );
              var MO_Date = new Date(m["MO_Date"]);
              //# => Fri Apr 01 2011 11:14:50 GMT+0200 (CEST)

              return (
                MO_Date.getDate() === yesterday.getDate() &&
                MO_Date.getFullYear() === yesterday.getFullYear() &&
                MO_Date.getMonth() === yesterday.getMonth() &&
                m["isdelete"]
              );
            } else if (listOfFillter[10].active) {
              var MO_Date_Month = new Date(m["MO_Date"]);
              //# => Fri Apr 01 2011 11:14:50 GMT+0200 (CEST)

              return (
                MO_Date_Month.getFullYear() === new Date().getFullYear() &&
                MO_Date_Month.getMonth() === new Date().getMonth() &&
                m["isdelete"]
              );
            }
            return true;
          });

          filtered = filtered.filter(m => {
            if (listOfFillter[13].active) {
              return (
                m["ReplyUserName"] === "adib@salmustasharak.com	" ||
                m["ReplyUserName"] === "muraqib"
              );
            } else if (listOfFillter[14].active) {
              return (

                m["ReplyUserName"] !== "test12" &&

                m["ReplyUserName"] !== "ahmad" &&
                m["ReplyUserName"] !== "adib@salmustasharak.com	" &&
                m["ReplyUserName"] !== "muraqib"
              );
            }
            return true;
            // return m['MOShortCode'] === parseInt (selectedGenre,10);
          });
        }

        var lengthSorter = function (value) {
          if (value["MO_Message"] == null) {
            return 0;
          }
          return value["MO_Message"].length;
        };
      }
    }

    const sorted =
      sortColumn.path === "MO_Message"
        ? _.orderBy(filtered, lengthSorter, [sortColumn.order])
        : _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const dreams = paginate(sorted, currentPage, pageSize);
    let filtered_Length = this.state.dreams;

    let totalCount_Sent = replyDreams.length;
    let totalCount_Muraqeeb = filtered_Length.filter(m => {
      if (m) {
        var date = new Date(m["MO_Date"]);
        if (
          m["CheckerName"] != null &&
          date.getDate() === new Date().getDate() &&
          date.getMonth() === new Date().getMonth() &&
          date.getFullYear() === new Date().getFullYear() &&
          m["CheckerName"] === "muraqib" && //this.state.user &&
          m["isRedyToSent"] === true &&
          m["isdelete"] === false
        ) {
          return true;
        }
      }
      return false;
    }).length;
    if (filtered) {
      return {
        totalCount: filtered.length,
        totalCountSent: totalCount_Sent,
        totalCountMuraqeeb: totalCount_Muraqeeb,
        data: dreams
      };
    } else {
      return { totalCount: 0, data: dreams };
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <div className="my-nice-tab-container">
          <div className="loading-state">
            <p>جاري تحميل البيانات</p>
          </div>
        </div>
      );
    } else {
      // const { length: count } = this.state.dreams;
      const { pageSize, currentPage, sortColumn, searchQuery, years } = this.state;
      // const { user } = this.props;

      // if (count === 0) return <p>لا يوجد بيانات </p>;

      const {
        totalCount,

        data: dreams
      } = this.getPagedData();

      return (
        <React.Fragment>
          <NavBar user={this.state.user} />

          <Modal
            isOpen={this.state.modalIsOpen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            style={{
              overlay: {
                backgroundColor: "papayawhip",
                zIndex: 100
              }
            }}
          >
            <div>
              {" "}
              <button
                onClick={this.closeModal}
                className="btn text-right btn-success btn-sm"
              >
                اغلاق النافذة
              </button>
            </div>
            <AllDreams mobOldData={this.state.alldata} />
          </Modal>
          <ListGroup
            items={this.state.listOfFillter}
            sc={this.state.sc}
            selectedItem={this.state.selectedGenre}
            onItemSelect={this.handleGenreSelect}
          />
          <div className="row">
            <div className="col-lg-12">
              {/*      {user && (
              <Link
                to="/ddreams/new"
                className="btn btn-primary"
                style={{ marginBottom: 10 }}
              >
                New Dream
              </Link>
            )} */}

              <p className="text-right">
                {"      "}
                {"      "}
                لديك <font color="blue">{totalCount}</font> حلم في قاعدة
                البيانات.
                {"    "}
                <i
                  className="fa fa-calendar"
                  aria-hidden="true"
                  onClick={this.renderSortDate}
                  style={{ cursor: "pointer" }}
                />
                <select className="selectpicker" onChange={this.handelSelect}>
                  {years.map(year => (
                    <option
                      value={year}
                      key={year}

                    >
                      {year}
                    </option>
                  ))}
                </select>
                {/* todayCount:data.data.TodayCount,
    yesterdayCount:data.data.YesterdayCount,
    mudakekCount:data.data.TodayCountMuraqeeb */}
                {this.renderSortIcon()} &nbsp;&nbsp; &nbsp;&nbsp;
                {this.state.searchQuery2 !== "" ? (
                  <React.Fragment>
                    {this.state.skip === 0 ? (
                      <i
                        className="fa fa-chevron-circle-right"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                      />
                    ) : (
                      <React.Fragment>
                        <i
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                          onClick={this.handleNext}
                        />{" "}
                        &nbsp;&nbsp; &nbsp;&nbsp;
                        <i
                          className="fa fa-chevron-circle-left"
                          style={{ cursor: "pointer" }}
                          aria-hidden="true"
                          onClick={this.handleBack}
                        />{" "}
                      </React.Fragment>
                    )}{" "}
                  </React.Fragment>
                ) : (
                  ""
                )}
              </p>
              {this.state.loadSearchData ? (
                <div
                  className="text-right text-danger  "
                  style={{ direction: "rtl" }}
                >
                  "جاري تحميل البيانات من قاعدة البيانات يرجى الانتظار ...."
                </div>
              ) : (
                <div style={{ direction: "rtl" }}>
                  {this.state.searchQuery2}
                  <SearchBox2
                    value={searchQuery}
                    onChange={this.handleSearch}
                    onKeyPress={this.handleKeyPress}
                  />
                </div>
              )}

              <Pagination
                itemsCount={totalCount}
                pageSize={pageSize}
                currentPage={currentPage}
                onPageChange={this.handlePageChange}
              />

              <DreamsTableSearch
                dreams={dreams}
                sortColumn={sortColumn}
                onLike={this.handleLike}
                onLock={this.handleLock}
                onSendMsg={this.handleSendMsg}
                onKeywordsMsg={this.handleKeywordsMsg}
                onDelete={this.handleDeleteConfirm}
                onOpenModel={this.openModal}
                onSort={this.handleSort}
                //  onFocusMob={this.getMobFoucs}
                onChangeText={this.handleChangeInput}
                onGetAll={this.handleGetAll}
                onUnLockAll={this.onUnLockAll}
                shouldHide={this.state.shouldHide}
              />

              <Pagination
                itemsCount={totalCount}
                pageSize={pageSize}
                currentPage={currentPage}
                onPageChange={this.handlePageChange}
              />

              {!this.state.shouldHide && <AllDreams mob={this.state.mobile} />}
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default DreamsSearch;

export const snapshotToArray = snapshot => {
  let returnArr = [];

  snapshot.forEach(childSnapshot => {
    let item = childSnapshot.val();
    item.key = childSnapshot.key;
    returnArr.push(item);
  });

  return returnArr;
};



// WEBPACK FOOTER //
// ./src/components/dreamsSearch.jsx